(ns app.components.icons.views
  (:require
   [re-com.core :as re-com :refer [at]]
   [app.components.icons.styles :refer [active-icon]]))

(defn folder-icon [{:keys [size]}]
  [:svg
   {:width "24px"
    :height "24px"
    :fill "none"
    :style {:minWidth "24px"}
    :xmlns "http://www.w3.org/2000/svg"}
   [:path
    {:d "M21 13C21 19.5 20 21 12 21C5 21 3 20 3 12.5C3 5 5 4 9 4C14 4 12 7 16 7C19 7 21 7 21 13Z"
     :stroke "#2B2A35"
     :strokeWidth "1.5"
     :strokeLinecap "round"
     :strokeLinejoin "round"}]])

(defn product-icon [{:keys [size]}]
  [:img {:src "/icons/product.svg" :width size :height size}])

(defn form-icon [{:keys [size]}]
  [:img {:src "/icons/form.svg" :width size :height size}])

(defn elipsis-icon [{:keys [size]}]
  [:img {:src "/icons/Elipsis.svg" :width size :height size}])

(defn plus-icon [{:keys [size]}]
  [:img {:src "/icons/Plus.svg" :width size :height size}])

(defn plus-white-icon [{:keys [size]}]
  [:img {:src "/icons/Plus_white.svg" :width size :height size}])

(defn plus-grey-icon [{:keys [size]}]
  [:img {:src "/icons/plus-grey.svg" :width size :height size}])

(defn dashboard-icon [{:keys [size active]}]
  [:img {:src "/icons/Dashboard.svg" :width size :height size}])

(defn chevron-down-icon [{:keys [size]}]
  [:img {:src "/icons/Chevron_down.svg" :width size :height size}])

(defn chevron-up-icon [{:keys [size]}]
  [:img {:src "/icons/chevron_up.png" :alt "chevron_icon" :width size :height size}])

(defn users-icon [{:keys [size]}]
  [:img {:src "/icons/users.svg"}])

(defn chart-icon [{:keys [size]}]
  [:img {:src "/icons/Chart.svg"}])

(defn link-icon [{:keys [size]}]
  [:img {:src "/icons/Link.svg"}])

(defn copy-icon [{:keys [size]}]
  [:img {:src "/icons/Copy.svg"}])

(defn settings-icon [{:keys [size]}]
  [:img {:src "/icons/settings.svg"}])

(defn download-icon [{:keys [size]}]
  [:img {:src "/icons/download.svg"}])

(defn new-folder-icon [{:keys [size]}]
  [:img {:src "/icons/new_folder.png"}])

(defn outlook-icon [{:keys [size]}]
  [:img {:src "/icons/outlook-icon.png" :width size :height size}])

(defn google-icon [{:keys [size]}]
  [:img {:src "/icons/google-icon.png" :width size :height size}])

(defn mail-icon [{:keys [size]}]
  [:img {:src "/icons/mail.png" :width size :height size}])

(defn avatar [{:keys [src size]}]
  [:img {:src src :alt "avatar" :class (active-icon) :width size :height size :referrerPolicy "no-referrer"}])

(defn eye-icon [{:keys [size style]}]
  [:img {:src "/icons/eye.svg" :width size :height size :style style}])

(defn eye-off-icon [{:keys [size]}]
  [:img {:src "/icons/eye_off.svg" :width size :height size}])

(defn copy-link-icon [{:keys [size]}]
  [:img {:src "/icons/copy_link.svg" :width size :height size}])

(defn edit-icon [{:keys [size]}]
  [:img {:src "/icons/edit.svg" :width size :height size}])

(defn delete-icon [{:keys [size]}]
  [:img {:src "/icons/trash.svg" :width size :height size}])

(defn search-icon [{:keys [size]}]
  [:img {:src "/icons/search.svg" :width size :height size}])

(defn search-icon-small [{:keys [size]}]
  [:img {:src "/icons/search-sm.svg" :width size :height size}])

(defn logout-icon [{:keys [size]}]
  [:img {:src "/icons/logout.svg" :width size :height size}])
(defn view-icon [{:keys [size]}]
  [:img {:src "/icons/view.svg" :width size :height size}])

(defn duplicate-icon [{:keys [size]}]
  [:img {:src "/icons/duplicate.svg" :width size :height size}])

(defn move-copy-to-icon [{:keys [size]}]
  [:img {:src "/icons/move-copy-to.svg" :width size :height size}])

(defn arrow-left-icon [{:keys [size]}]
  [:img {:src "/icons/arrow_left.svg" :width size :height size}])

(defn arrow-up-icon [{:keys [size class]}]
  [:img {:src "/icons/arrow-up.svg" :width size :height size :class class}])

(defn arrow-down-icon [{:keys [size class]}]
  [:img {:src "/icons/arrow-down.svg" :width size :height size :class class}])

(defn trash-big-icon [{:keys [size]}]
  [:img {:src "/icons/trash-big.svg" :width size :height size}])

(defn recycle-trash-icon [{:keys [size]}]
  [:img {:src "/icons/recycle-trash-example.svg" :width size :height size}])

(defn not-found-icon [{:keys [size]}]
  [:img {:src "/icons/404-example.svg" :width size :height size}])

(defn empty-folder-icon [{:keys [size]}]
  [:img {:src "/icons/empty-folder.png" :width size :height size}])


(defn profile-icon [{:keys [size]}]
  [:img {:src "/icons/profile.svg" :width size :height size}])

(defn grid-view-icon [{:keys [size]}]
  [:img {:src "/icons/grid-view.svg" :width size :height size}])

(defn list-view-icon [{:keys [size]}]
  [:img {:src "/icons/list-view.svg" :width size :height size}])

(defn close-icon [{:keys [size]}]
  [:img {:src "/icons/close.svg" :width size :height size}])

(defn back-arrow-form-icon [{:keys [width height]}]
  ;without adding the style the click function is not working 
  [:img {:src "/icons/back_arrow.png" :alt "back_arrow" :width width :height height :style {:webkittransform "scaleX(1)" :transform "scaleX(1)"}}])

(defn next-arrow-form-icon [{:keys [width height]}]
  [:img {:src "/icons/back_arrow.png" :alt "next_arrow" :width width :height height :style {:webkittransform "scaleX(-1)" :transform "scaleX(-1)"}}])

(defn restart-icon [{:keys [size]}]
  [:img {:src "/icons/restart.png" :width size :height size}])
(defn warning-icon [{:keys [size]}]
  [:img {:src "/icons/alert_triangle.svg" :width size :height size}])
